<template>
  <div>
    <Echart
      :options="options"
      id="centreLeft1Chart"
      height="250px"
      width="440px"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        const colors = [
          new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
            { offset: 0, color: '#20e4cd' },
            { offset: 1, color: '#2d92ff' }
          ]),
          new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
            { offset: 0, color: '#ff5f8f' },
            { offset: 1, color: '#ff9564' }
          ]),
          new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
            { offset: 0, color: '#3978ff' },
            { offset: 1, color: '#8b6cff' }
          ]),
          new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
            { offset: 0, color: '#ffe16b' },
            { offset: 1, color: '#ff9138' }
          ])
        ]
        this.options = {
          color: colors,
          animationDuration: 1000,
          title: {
            text: '249',
            subtext: '合同总数',
            left: 'center',
            top: '31%',
            textStyle: {
              color: '#f2fbff',
              fontSize: 28,
              fontWeight: 'bold',
              textShadowBlur: 12,
              textShadowColor: 'rgba(65, 221, 234, 0.45)'
            },
            subtextStyle: {
              color: '#8190ad',
              fontSize: 11,
              lineHeight: 18
            }
          },
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(8, 16, 36, 0.96)',
            borderColor: '#2fc8dc',
            borderWidth: 1,
            formatter: '{b}<br/>{c} 份（{d}%）'
          },
          legend: {
            orient: 'horizontal',
            icon: 'circle',
            bottom: 0,
            x: 'center',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 18,
            data: newData.xData,
            textStyle: {
              color: '#aebbd1',
              fontSize: 11
            }
          },
          series: [
            {
              name: '对下合同',
              type: 'pie',
              radius: ['38%', '62%'],
              center: ['50%', '43%'],
              minAngle: 5,
              avoidLabelOverlap: true,
              itemStyle: {
                borderColor: '#0a1325',
                borderWidth: 3,
                shadowBlur: 12,
                shadowColor: 'rgba(42, 173, 221, 0.2)'
              },
              label: {
                show: true,
                color: '#dbe7f7',
                fontSize: 10,
                formatter: '{name|{b}}\n{value|{c}份}  {percent|{d}%}',
                rich: {
                  name: { color: '#aebbd1', lineHeight: 16 },
                  value: { color: '#ffffff', fontWeight: 'bold' },
                  percent: { color: '#58e6dc' }
                }
              },
              labelLine: {
                length: 10,
                length2: 8,
                lineStyle: {
                  color: 'rgba(126, 205, 223, 0.5)'
                }
              },
              data: newData.seriesData.map((item, index) => ({
                ...item,
                itemStyle: { color: colors[index] }
              }))
            }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
